




















import { Vue, Component } from 'vue-property-decorator';
import { Banner } from '@/components';
import { OPTHINES } from './config';
import { getBaseInfo, getRules } from './api/index';
import { Popup } from 'vant';
Vue.use(Popup);
@Component({
  components: {
    Banner,
  },
})
export default class ApplyLink extends Vue {
  option = OPTHINES;
  baseInfo = {};
  Rules = '';
  async created() {
    const res = await getRules();
    this.Rules = res.data;
    getBaseInfo().then((res: any) => {
      this.$addPv(res.data.activityId);
      this.baseInfo = res.data;
    });
  }

  copyText() {
    (this.$refs.link as HTMLInputElement).select();
    document.execCommand('copy'); // 执行浏览器复制命令
    window.alert('复制成功');
  }
}
